import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Chip from '@zenbusiness/zui/Chip';
import IconButton from '@zenbusiness/zui/IconButton';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledCard = superstyled({
  name: 'BillingHistoryCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginBlock: theme.spacing(3),
    },
  }),
});

export const StyledTableContainer = superstyled({
  name: 'BillingHistoryTableContainer',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      marginInline: theme.spacing(-2),
    },
  }),
});

export const StyledTable = superstyled({
  name: 'BillingHistoryTable',
  slot: 'Root',
  tag: 'table',
  styles: ({ theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    '& thead': {
      backgroundColor: theme.palette.grey[50],
      borderBottom: `2px solid ${theme.palette.divider}`,
    },
    '& th': {
      padding: theme.spacing(2),
      textAlign: 'left',
      fontWeight: 600,
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
        fontSize: '0.75rem',
      },
    },
    '& td': {
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
    },
    '& tbody tr': {
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
});

export const StyledStatusChip = superstyled({
  name: 'BillingHistoryStatusChip',
  slot: 'Root',
  tag: Chip,
  propsNeeded: ['status'],
  styles: ({ status, theme }) => {
    const statusColors = {
      paid: {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.contrastText,
      },
      pending: {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.contrastText,
      },
      refunded: {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.text.primary,
      },
      failed: {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.contrastText,
      },
    };

    return statusColors[status] || statusColors.pending;
  },
});

export const StyledPaymentBadge = superstyled({
  name: 'PaymentMethodBadge',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.875rem',
  }),
});

export const StyledDownloadButton = superstyled({
  name: 'BillingHistoryDownloadButton',
  slot: 'Root',
  tag: IconButton,
  styles: ({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: `${theme.palette.primary.light}20`,
    },
  }),
});

export const StyledEmptyState = superstyled({
  name: 'BillingHistoryEmptyState',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }),
});

export const StyledSortButton = superstyled({
  name: 'BillingHistorySortButton',
  slot: 'Root',
  tag: 'button',
  styles: ({ theme }) => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: 0,
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  }),
});
